/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * user roles (mroService.getRoles) held in redux state
 *
 *==================================================
 */
import { RootReducerState } from "../reducers";
import {
  MDG_ADVANCED_USER_ROLE_NAME,
  MRO_ENGINEERS_ROLE_NAME,
  SUPER_USER_ROLE_NAME,
} from "../../constants/user";

const userRolesSelector = (state: RootReducerState) => {
    return state.userRoles;
}

const hasRole = (state: RootReducerState, roleName: string) => {
    return (state.userRoles?.roles ?? []).some((r: any) => (r.name === roleName));
}

const isSuperUserSelector = (state: RootReducerState) => {
    return hasRole(state, SUPER_USER_ROLE_NAME);
}

const isMdgAdvancedSelector = (state: RootReducerState) => {
    return hasRole(state, MDG_ADVANCED_USER_ROLE_NAME);
}

const isEngineerSelector = (state: RootReducerState) => {
    return hasRole(state, MRO_ENGINEERS_ROLE_NAME);
}

export {
    userRolesSelector,
    isSuperUserSelector,
    isMdgAdvancedSelector,
    isEngineerSelector,
}
